"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookingOrderPage = bookingOrderPage;
exports.exportBookingOrderInfo = exportBookingOrderInfo;
exports.getBookingOrderDetail = getBookingOrderDetail;
exports.writeOffBookingOrder = writeOffBookingOrder;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function bookingOrderPage(query) {
  return (0, _requestPIM.default)({
    url: '/xyGaBookingOrder/page',
    method: 'get',
    params: query
  });
}
function getBookingOrderDetail(bookingOrderId) {
  return (0, _requestPIM.default)({
    url: "/xyGaBookingOrder/".concat(bookingOrderId),
    method: 'get'
  });
}
function writeOffBookingOrder(data) {
  return (0, _requestPIM.default)({
    url: '/xyGaBookingOrder/writeOff',
    method: 'post',
    data: data
  });
}

// 导出预订订单信息
function exportBookingOrderInfo(query) {
  return (0, _requestPIM.default)({
    url: '/xyGaBookingOrder/exportBookingOrderInfo',
    method: 'get',
    params: query
  });
}